import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Wminput from "../ui-components/wm-form-components/input/Wm.input";
import WmTextarea from "../ui-components/wm-form-components/textarea/Wm.Textarea";
import "./posts.css";
import Categories from "../ui-components/categories/Categories";
import PostTypes from "./PostTypes";
import { connect } from "react-redux";
import { decode } from "base-64";
import { Container, Row, Col } from "react-bootstrap";
import downArrow from "../assets/images/down-arrow.svg";
import FileUploader from "../ui-components/fileUploader/FileUploader";
import InputTags from "../ui-components/tags/InputTags";
import Wmbutton from "../ui-components/wm-button/Wm.button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Editor from "../Components/Editor/Editor";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import Cookies from "universal-cookie";
import { getUsersEntireData } from "../functions/apis"
import { encode } from "base-64";
// ACTIONS
import { handleQuestionForBlogs, handleDescriptionForBlogs, handleDateForBlogs, handleTagsForBlogs, handleCategoryForBlogs, commentsOnForBlog, addCategoryCheck, addBlogContent, addBlogCoverImage, fetchCategoryFromApi, getCategory, removeBlogHeadImage, resetBlogContent, setMasterData } from "../services/actions/actions";
import EditBlog from "./EditBlog";
import WmModals from "../modals/Wm.Modals";
import { CheckCircleIcon, ClipboardCopyIcon, XIcon } from "@heroicons/react/outline";
const Cookie = new Cookies();
function CreateBlog({ isEdit, blogData, addQuestion, addDescriptionBlog, addTagsBlog, addCategoryBlog, addCommentsBlog, handleCategoryCheck, handleBlogContent, handleCoverImage, setFetchApi, getCategoryFormApi, removeBlogImage, mapDataToState, resetBlogContents, setData }) {
  const history = useHistory();
  var tokens = Cookie.get("wmtoken");
  useEffect(() => { if (!tokens) { history.push(`/login?service=${encode('createblogs')}`) } }, [])
  const blogsPreview = () => { history.push(`/preview_blogs`); };
  const [isPostSelect, setShowPostSelect] = useState(true);
  const getTypesOfPost = () => { setShowPostSelect(false); };
  // CREATE BLOG
  const [isCreating, setIsCreating] = useState(false);
  const [publishLinkModal, setOpenPublishLinkModal] = useState(false)
  const [slugUrl, setSlugUrl] = useState('')
  const createBlogPost = (e) => {
    setIsCreating(true)
    var fd = new FormData();
    e.preventDefault();
    fd.append("token", decode(tokens));
    fd.append("identity", API_ENDPOINT.identity);
    fd.append("post_type", "blog");
    fd.append("content", blogData.content);
    fd.append("title", blogData.question);
    fd.append("description", blogData.description);
    fd.append("reply_status", blogData.isComment ? "1" : "0");
    fd.append("post_media", blogData.blogFile);
    fd.append("category", JSON.stringify([...blogData.category]));
    fd.append("tags", JSON.stringify([...blogData.tags]));
    axios({ method: "post", url: `${API_ENDPOINT.apiURL}Profile/createPost`, data: fd })
      .then(function (response) {
        setSlugUrl(response.data.url)
        getUsersEntireData().then(function (res) { setData(res) })
        addQuestion("");
        addDescriptionBlog("");
        addCommentsBlog(true);
        setIsCreating(false)
        resetBlogContents()
        setOpenPublishLinkModal(true);
      })
      .catch(function (error) {
        setIsCreating(false)
        alert(error.response.data.validation_error);
      });
  };
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const resetModal = () => {
    setIsResetModalOpen(true);
  };
  if (Cookie.get("wmusers")) {
    var user = decode(Cookie.get("wmusers"));
  } else {
    var user = 'members';
  }
  const [linkCopied, setLinkCopied] = useState(false)
  const copyLink = (text) => {
    navigator.clipboard.writeText(text).then(function () {
      setLinkCopied(true)
      window.location.reload(false);
    }, function (err) {
      alert(err)
    });
  }
  return (
    <React.Fragment>
      <React.Fragment>
        {!isEdit ? (
          <React.Fragment>
            <div className="createBlog -mt-8 container-fluid">
              <h3 className=" mb-4">Add New Posts</h3>
              <div className="wm-form-group flex flex-col mb-4">
                <label htmlFor="First name" className="text-sm">Enter Title Here</label>
                <Wminput type="text" name="blogTitle" value={blogData.question} placeholder="Title Here...." onChange={(e) => addQuestion(e.target.value)} />
              </div>
              <div className="row createFormLayoutDivision flex">
                <div className="col-xl-9 col-lg-9 col-md-9">
                  <div className="leftCreateSection">
                    <div className="wm-form-group flex flex-col mb-4">
                      <label htmlFor="First name" className="text-sm">Description</label>
                      <WmTextarea value={blogData.description} placeholder="Description Here...." onChange={(e) => addDescriptionBlog(e.target.value)} />
                    </div>
                    <div className="uploadArea h-40 w-full">
                      <FileUploader handleCoverImageUpload={(e) => handleCoverImage(e)} image={blogData.headImage} removeHeadImage={removeBlogImage} allowTypes={"image/png, image/jpeg, image/jpg"} />
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3">
                  <div className="rightCreateSection">
                    {user === 'member' && <div onClick={() => getTypesOfPost()} className="postSelectionWrapper cursor-pointer relative hidden lg:flex items-center h-10 border-bottom border-gray-300 mb-4">
                      <p className="mb-0 flex-1">Blogs</p>
                      <img src={downArrow} alt="downArrow" className="w-4 cursor-pointer" />
                      <PostTypes isPostSelect={isPostSelect} close={() => setShowPostSelect(true)} />
                    </div>}
                    <div className="wm-form-group mb-4 mt-4 lg:mt-0">
                      <div className="catogryWrapper border rounded-md p-3">
                        <Categories mainCategoriesClass="categoryContainer" list={blogData.categoryStore} listFromRedux={blogData.category} data={addCategoryBlog} checkBoxHandler={handleCategoryCheck} isFetchCat={blogData.isFetchCat} getCategory={getCategoryFormApi} onClickHitApi={setFetchApi} />
                      </div>
                    </div>
                    <div className="wm-form-group mb-4">
                      <h5 className="mb-2 font-medium text-sm">Tags</h5>
                      <div className="tagsWrapper">
                        <InputTags getTags={addTagsBlog} selected={blogData.tags} />
                        <p className="text-gray-600 text-xs manpro mt-3">Please hit <span className="px-2 py-1 bg-gray-300 rounded inline-block">Enter</span> after every tag.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div>
                    <div className="textEditor mt-4">
                      <Editor onEditorStateChange={(e, value) => handleBlogContent(value)} value={blogData.content} />
                    </div>
                  </div>
                  <div className="wm-form-group mb-4 flex space-x-4 mt-4">
                      <div className="">
                        <Wmbutton label="Preview" className="rounded mb-3 mr-0 w-full px-4" type="button" color="primary" onClick={() => blogsPreview()} />
                      </div>
                      <div className="">
                        <Wmbutton label={isCreating ? (<CircularProgress className="loader_size_xsm text-white" />) : ("Publish")} className="rounded mb-3 mr-0 w-full px-4" type="button" color="primary" onClick={(e) => { createBlogPost(e) }} />
                      </div>
                      <div className="">
                        <Wmbutton label="Reset" className="rounded mb-3 mr-0 w-full px-4" type="button" color="primary" onClick={() => resetModal()} />
                      </div>
                      <div className="">
                        <Wmbutton label="Back" className="rounded mb-3 w-full px-4" type="button" color="primary" onClick={() => history.goBack()} />
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <EditBlog />
        )}
      </React.Fragment>
      <WmModals show={isResetModalOpen} onHide={() => setIsResetModalOpen(false)} size="md" className="">
        <Container fluid className="py-4">
          <Row>
            <Col md={12}>
              <div className="text-center mb-4">
                <span className="block">Are you sure you want to reset the content</span>
                <span className="block">This will erase all above content permenantly!!!!</span>
              </div>
            </Col>
            <Col md={12}>
              <div className="text-right">
                <Wmbutton label="Reset" className="rounded w-20 mr-3" type="button" size="sm" color="danger" onClick={() => { resetBlogContents(); setIsResetModalOpen(false); }} />
                <Wmbutton label="Cancel" className="rounded w-20" type="button" color="primary" onClick={() => setIsResetModalOpen(false)} />
              </div>
            </Col>
          </Row>
        </Container>
      </WmModals>

      <WmModals show={publishLinkModal} onHide={() => { setOpenPublishLinkModal(false); setLinkCopied(false) }} size="md" className="overflow-hidden">
        <div className="relative">
          <XIcon className=" absolute w-5 text-black right-4 top-4 cursor-pointer" onClick={() => { setOpenPublishLinkModal(false); setLinkCopied(false); window.location.reload(false); }} />
          <div className="w-full h-48 flex items-center justify-center bg-green-200">
            <CheckCircleIcon className="w-20 h-20 text-green-700" />
          </div>
          <div className="text-center p-4">
            <span className="block manpro text-4xl text-gray-700">Great!</span>
            <span className="block manpro text-lg text-gray-700 font-semibold my-3">Your blog is published successfully.</span>
            {linkCopied && <span className="bg-green-200 text-green-700 px-3 py-1 rounded inline-block mb-2">Copied to clipboard</span>}
            <div>
              <div onClick={() => copyLink(`${API_ENDPOINT.redirectURL}/blogs/${slugUrl}`)} className="flex items-center justify-between cursor-pointer border rounded-md py-2  px-3 divide-x hover:shadow">
                <span className="block wordClamp-1">{`${API_ENDPOINT.redirectURL}/blogs/${slugUrl}`}</span>
                <ClipboardCopyIcon className="w-10 pl-3" />
              </div>
            </div>
          </div>
        </div>
      </WmModals>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    addQuestion: (value) => {
      dispatch(handleQuestionForBlogs(value));
    },
    addDescriptionBlog: (value) => {
      dispatch(handleDescriptionForBlogs(value));
    },
    addDateBlog: (value) => {
      dispatch(handleDateForBlogs(value));
    },
    addTagsBlog: (value) => {
      dispatch(handleTagsForBlogs(value));
    },
    addCategoryBlog: (value) => {
      dispatch(handleCategoryForBlogs(value));
    },
    addCommentsBlog: (value) => {
      dispatch(commentsOnForBlog(value));
    },
    handleCategoryCheck: (idx, value, bool) => {
      dispatch(addCategoryCheck(idx, value, bool));
    },
    handleBlogContent: (value) => {
      dispatch(addBlogContent(value));
    },
    handleCoverImage: (value) => {
      dispatch(addBlogCoverImage(value));
    },
    setFetchApi: () => {
      dispatch(fetchCategoryFromApi());
    },
    getCategoryFormApi: (idx, value) => {
      dispatch(getCategory(idx, value));
    },
    removeBlogImage: () => {
      dispatch(removeBlogHeadImage());
    },
    resetBlogContents: () => {
      dispatch(resetBlogContent());
    },
    setData: (value) => {
      dispatch(setMasterData(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(CreateBlog);
